/**
 * Created by wangmc on 2018/3/13.
 */

import { domain } from  './lib/env'
import api from './lib/ajax'
import {
    readCookie,
    createCookie,
    getHashUrlQuery,
    getUrlQuery
} from  './lib/method'

export default api

export {
    domain,

    readCookie,
    createCookie,
    getHashUrlQuery,
    getUrlQuery
}


// WEBPACK FOOTER //
// ./node_modules/teld-web-component/index.js